import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import $ from 'jquery';
import 'datatables.net'; // Import DataTables
import { jwtDecode } from 'jwt-decode';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { Helmet } from "react-helmet-async";
import Swal from "sweetalert2";
import { query, where, uploadBytesResumable, getDownloadURL, db, collection, addDoc, doc, getDoc, setDoc, getDocs, deleteDoc, updateDoc, writeBatch, limit } from '../../config/firebaseConfig.js'; // Pastikan jalur benar


const HasilUjian = () => {
    const location = useLocation(); // Gunakan useLocation untuk membaca query string

    const queryParams = new URLSearchParams(location.search);

    const kode = queryParams.get('kode');

    const [dataPeserta, setDataPeserta] = useState([]); // State untuk menyimpan daftar kelas
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const [dataSoal, setDatasoal] = useState([]); // State untuk menyimpan daftar kelas

    const [dataUjian, setDataUjian] = useState([]);


    const getDataRefrensi = useCallback(async () => {
        try {
            Swal.fire({
                title: 'Loading...',
                text: 'Mencoba memuat data jawaban',
                allowOutsideClick: false,
                allowEscapeKey: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });
            // Kirim request ke server dengan header level user
            const response = await fetch(`${process.env.REACT_APP_BASE_URL}/admin/refrensi/getjawbaan?kode=${kode}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer " + localStorage.getItem("token")
                },
            });

            if (!response.ok) {
                throw new Error("Failed to fetch kelas");
            }

            const data = await response.json();
            setDataPeserta(data.dataJawaban)
            console.log(data.dataJawaban.length)

            setDatasoal(data.dataSoal)

            setDataUjian(data.dataUjian)
            Swal.close();
            if (!data.dataJawaban || data.dataJawaban.length === 0) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Jawaban dan soal belum ada',
                    text: 'Silahkan tarik data hasil dan soal jika ujian telah dilakukan',
                    showCancelButton: true,
                    confirmButtonText: 'Tarik Data Sekarang',
                    cancelButtonText: 'Nanti Saja',
                }).then((result) => {
                    if (result.isConfirmed) {

                        tarikhasilujian()
                    } else {
                        // User klik "Nanti Saja" atau tutup swal, tidak perlu aksi tambahan
                    }
                });
            }

        } catch (error) {
            Swal.close();
            Swal.fire({
                icon: "error",
                title: "Gagal!",
                text: error.message || 'Something went wrong',
            });
            setError(error.message || 'Something went wrong');
        }
    }, []);


    useEffect(() => {
        const authToken = localStorage.getItem('authToken');
        if (!authToken) {
            console.error("Token required");
            return; // Jika tidak ada token, hentikan eksekusi
        }

        try {
            // Decode payload dari token JWT
            const decoded = jwtDecode(authToken);


        } catch (error) {
            console.error("Invalid token:", error);
            navigate('/login'); // Jika token tidak valid, arahkan ke halaman login
            return;
        }


    }, []);
    useEffect(() => {
        getDataRefrensi(); // Ambil data referensi awal



        // Inisialisasi ulang DataTables setelah data diperbarui
        if (dataPeserta?.jadwal?.length > 0) {
            if ($.fn.dataTable.isDataTable('.table')) {
                $('.table').DataTable().destroy(); // Hancurkan DataTable yang lama
            }

            $('.table').DataTable({
                "dom": "<'row'<'col-6 col-sm-6 col-md-9'f><'col-6 col-sm-6 col-md-2 'B><'col-sm-6 col-md-1 float-right'l>><'row'<'col-sm-12'tr>><'row'<'col-sm-12 col-md-10'p><'col-sm-12 col-md-2'i>>",
                "language": {
                    "search": "",
                    "lengthMenu": "_MENU_"
                },
            });
        }
    }, []); // Pastikan efek hanya berjalan saat data berubah
    // Inisialisasi ulang hanya ketika `kelas` berubah



    dataSoal.forEach(item => {
        console.log(`ID: ${item.id}, Point:`, item.point, "Type:", typeof item.point);
    });

    const jmls = dataSoal.length;
    const totalskor = dataSoal.reduce((acc, item) => acc + (parseFloat(item.poin) || 0), 0);
    dataSoal.map((d) => {
        console.log("fff" + d.poin || 0)

    })


    const exportToExcel = async () => {
        if (!dataPeserta || dataPeserta.length === 0) {
            console.warn("Data peserta tidak tersedia");
            return;
        }

        const workbook = XLSX.utils.book_new();

        // 1. Soal Ganda
        const soalGanda = dataSoal
            .filter(s => s.tipe !== 'essay' && JSON.parse(s.jawaban || "[]").length > 0)
            .map(s => {
                const jawabanSoal = JSON.parse(s.jawaban || "[]");
                const kunci = jawabanSoal.filter(j => j.kunci === 1).map(j => j.text).join(", ");
                return {
                    "No Soal": s.id_soal,
                    "Pertanyaan": s.soal,
                    "Kunci": kunci,
                    "Bobot": s.poin
                };
            });
        XLSX.utils.book_append_sheet(workbook, XLSX.utils.json_to_sheet(soalGanda), "Soal Ganda");

        // 2. Soal Essay
        const soalEssay = dataSoal
            .filter(s => s.tipe === 'essay' || JSON.parse(s.jawaban || "[]").length === 0)
            .map(s => ({
                "No Soal": s.id_soal,
                "Pertanyaan": s.soal,
                "Bobot": s.poin
            }));
        XLSX.utils.book_append_sheet(workbook, XLSX.utils.json_to_sheet(soalEssay), "Soal Essay");
        // 5. Poin Soal
        const poinPerPeserta = dataPeserta.map((item, index) => {
            const rowData = {
                "#": index + 1,
                "Nama": item.nama_peserta,
            };

            let totalBenar = 0;
            let skor = 0;
            let jawabanArray = [];

            try {
                jawabanArray = JSON.parse(item.jawaban || "[]");
            } catch (error) {
                console.error("Error parsing jawaban:", error);
            }

            dataSoal.forEach((soal, nos) => {
                const soalJawaban = JSON.parse(soal.jawaban || "[]");
                const jawabanItem = jawabanArray.find(j => j.idsoal === soal.id_soal);
                const jnss = soal.jenis

                if (!jawabanItem) {
                    rowData[`Soal ${nos + 1} (${jnss})`] = 0;
                    return;
                }

                if (soalJawaban.length === 0) {
                    // Esai → poin tetap 0 (bisa Anda sesuaikan kalau perlu sistem penilaian esai)
                    rowData[`Soal ${nos + 1} (${jnss})`] = 0;
                } else {
                    const jawabanBenar = soalJawaban.filter(s => s.kunci === 1).map(s => s.id_jwb.toString());
                    const jawabanUser = Array.isArray(jawabanItem.jawaban)
                        ? jawabanItem.jawaban.map(s => s.id_jwb.toString())
                        : [jawabanItem.jawaban.id_jwb.toString()];

                    const benar = jawabanUser.length === jawabanBenar.length &&
                        jawabanUser.every(j => jawabanBenar.includes(j));

                    const poin = parseFloat(soal.poin) || 1;

                    if (jnss === "essay") {
                        const jawabanUserText = Array.isArray(jawabanItem.jawaban)
                            ? jawabanItem.jawaban.map(s => {
                                const found = soalJawaban.find(j => j.id_jwb.toString() === s.id_jwb.toString());
                                return found ? found.text : s.id_jwb;
                            }).join(", ")
                            : (() => {
                                const found = soalJawaban.find(j => j.id_jwb.toString() === jawabanItem.jawaban.id_jwb.toString());
                                return found ? found.text : jawabanItem.jawaban.id_jwb;
                            })();
                        rowData[`Soal ${nos + 1} (${jnss})`] = jawabanUserText;
                    } else {
                        if (benar) {
                            skor += poin;
                            totalBenar++;
                            rowData[`Soal ${nos + 1} (${jnss})`] = poin;
                        } else {
                            rowData[`Soal ${nos + 1} (${jnss})`] = 0;
                        }
                    }

                }
            });

            rowData["Total Poin"] = skor;
            return rowData;
        });

        const poinPerPesertaSheet = XLSX.utils.json_to_sheet(poinPerPeserta);
        XLSX.utils.book_append_sheet(workbook, poinPerPesertaSheet, "Rekap Point Jawaban Detail");
        // 4. Total Nilai
        const sheetNilai = dataPeserta.map((item, index) => {
            let jawabanArray = [];
            try {
                jawabanArray = JSON.parse(item.jawaban || "[]");
            } catch { }

            let skor = 0;
            let totalBenar = 0;

            dataSoal.forEach((soal) => {
                const soalJawaban = JSON.parse(soal.jawaban || "[]");
                const jawabanItem = jawabanArray.find(j => j.idsoal === soal.id_soal);
                if (!jawabanItem || soalJawaban.length === 0) return;

                const jawabanBenar = soalJawaban.filter(s => s.kunci === 1).map(s => s.id_jwb.toString());
                const jawabanUser = Array.isArray(jawabanItem.jawaban)
                    ? jawabanItem.jawaban.map(s => s.id_jwb.toString())
                    : [jawabanItem.jawaban.id_jwb.toString()];

                const benar = jawabanUser.length === jawabanBenar.length &&
                    jawabanUser.every(j => jawabanBenar.includes(j));

                const poin = parseFloat(soal.poin) || 1;
                if (benar) {
                    skor += poin;
                    totalBenar++;
                }
            });

            const totalPoinMaks = dataSoal
                .filter(s => JSON.parse(s.jawaban || "[]").length > 0)
                .reduce((sum, s) => sum + (parseFloat(s.poin) || 1), 0);

            const nilaiAkhir = (skor / totalPoinMaks) * 100;

            return {
                "#": index + 1,
                "Nama": item.nama_peserta,
                "Total Benar": totalBenar,
                "Skor": skor,
                "Nilai Akhir": nilaiAkhir.toFixed(2)
            };
        });
        XLSX.utils.book_append_sheet(workbook, XLSX.utils.json_to_sheet(sheetNilai), "Total Nilai");

        // 3. Semua Jawaban Peserta
        const hasilDatadetail = dataPeserta.map((item, index) => {
            const rowData = {
                "#": index + 1,
                "Nama": item.nama_peserta,
            };

            let totalBenar = 0;
            let skor = 0;
            let jawabanArray = [];

            try {
                jawabanArray = JSON.parse(item.jawaban || "[]");
            } catch (error) {
                console.error("Error parsing jawaban:", error);
            }

            dataSoal.forEach((soal) => {
                const soalJawaban = JSON.parse(soal.jawaban || "[]");
                const jawabanItem = jawabanArray.find(j => j.idsoal === soal.id_soal);

                if (!jawabanItem) {
                    rowData[`Soal ${soal.id_soal}`] = "-";
                    return;
                }

                if (soalJawaban.length === 0) {
                    const esai = jawabanItem.jawaban?.text || jawabanItem.jawaban || "-";
                    rowData[`Soal ${soal.id_soal}`] = esai;
                } else {
                    const jawabanBenar = soalJawaban.filter(s => s.kunci === 1).map(s => s.id_jwb.toString());
                    const jawabanUser = Array.isArray(jawabanItem.jawaban)
                        ? jawabanItem.jawaban.map(s => s.id_jwb.toString())
                        : [jawabanItem.jawaban.id_jwb.toString()];

                    const jawabanUserText = Array.isArray(jawabanItem.jawaban)
                        ? jawabanItem.jawaban.map(s => {
                            const found = soalJawaban.find(j => j.id_jwb.toString() === s.id_jwb.toString());
                            return found ? found.text : s.id_jwb;
                        }).join(", ")
                        : (() => {
                            const found = soalJawaban.find(j => j.id_jwb.toString() === jawabanItem.jawaban.id_jwb.toString());
                            return found ? found.text : jawabanItem.jawaban.id_jwb;
                        })();

                    const benar = jawabanUser.length === jawabanBenar.length &&
                        jawabanUser.every(j => jawabanBenar.includes(j));

                    const poin = parseFloat(soal.poin) || 1;
                    if (benar) {
                        skor += poin;
                        totalBenar++;
                    }

                    rowData[`Soal ${soal.id_soal}`] = `${jawabanUserText} (${benar ? poin : 0})`;
                }
            });

            rowData["Total"] = skor;
            return rowData;
        });
        XLSX.utils.book_append_sheet(workbook, XLSX.utils.json_to_sheet(hasilDatadetail), "Semua Jawaban");






        // Simpan file
        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        const fileData = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });

        const fileName = `${dataUjian.nama_rombel || "rombel"} - ${dataUjian.nama_mapel || "mapel"} rekap_ujian.xlsx`;
        saveAs(fileData, fileName);
    };




    const tarikhasilujian = async () => {
        Swal.fire({
            title: "Sinkronisasi Data Soal & Jawaban",
            html: "Menyiapkan data...",
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        try {
            // Ambil data jawaban dari Firestore
            const jawabanQuery = query(collection(db, "jawaban"), where("kode", "==", kode));
            const jawabanSnapshot = await getDocs(jawabanQuery);
            const jawabanData = [];
            const soalIDs = new Set(); // gunakan Set untuk menghindari duplikat
            jawabanSnapshot.forEach((doc) => {
                const data = doc.data();

                // hapus field text pada data.data.jawaban
                const cleanedData = {
                    ...data,
                    data: data.data?.map((item) => ({
                        ...item,
                        jawaban: item.jawaban?.map(({ text, ...rest }) => rest)
                    }))
                };
                console.log(cleanedData)

                jawabanData.push({ id: doc.id, ...cleanedData });

                // ambil id soal
                if (Array.isArray(data.data)) {
                    data.data.forEach((item) => {
                        if (item.idsoal) {
                            soalIDs.add(item.idsoal);
                        }
                    });
                }
            });
            console.log(jawabanData.data)

            console.log(`Total jawaban: ${jawabanData.length}`);
            console.log(`Total id_soal unik: ${soalIDs.size}`);

            // Ambil data soal berdasarkan id_soal
            const soalData = [];
            for (const id of soalIDs) {
                const docRef = doc(db, "soal", id);
                const docSnap = await getDoc(docRef);

                if (docSnap.exists()) {
                    const data = docSnap.data();

                    const cleanedData = {
                        ...data,
                        jawaban: Array.isArray(data.jawaban)
                            ? data.jawaban.map(({ text, ...rest }) => rest)
                            : data.jawaban
                    };

                    soalData.push({
                        id: docSnap.id,
                        ...cleanedData
                    }); console.log(data.jawaban)
                }

            }

            // Fungsi pembagi array menjadi chunk
            const chunkArray = (arr, size) => {
                return arr.reduce((acc, _, i) => {
                    if (i % size === 0) acc.push(arr.slice(i, i + size));
                    return acc;
                }, []);
            };

            const jawabanChunks = chunkArray(jawabanData, 2);
            const soalChunks = chunkArray(soalData, 2);

            let batchJawabanSuccess = 0;
            let batchSoalSuccess = 0;

            // Kirim batch jawaban
            Swal.update({ title: "Sinkronisasi Jawaban", html: "Mengirim data jawaban..." });
            for (const [index, chunk] of jawabanChunks.entries()) {


                try {
                    const response = await fetch(`${process.env.REACT_APP_BASE_URL}/admin/sycron/sycronjawbaan`, {
                        method: "POST",
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': "Bearer " + localStorage.getItem("token")
                        },

                        body: JSON.stringify({ data: chunk }),
                    });

                    if (!response.ok) throw new Error(`Gagal kirim jawaban batch ke-${index + 1}`);
                    batchJawabanSuccess++;

                    Swal.update({
                        html: `Jawaban batch ke-${index + 1} dikirim. <br>${batchJawabanSuccess}/${jawabanChunks.length} sukses.`,
                    });
                } catch (err) {
                    console.error(`Jawaban batch ke-${index + 1} gagal:`, err);
                    Swal.update({
                        html: `Jawaban batch ke-${index + 1} gagal. <br>${batchJawabanSuccess}/${jawabanChunks.length} sukses.`,
                    });
                }

                await new Promise((res) => setTimeout(res, 1000));
            }

            // Kirim batch soal
            Swal.update({ title: "Sinkronisasi Soal", html: "Mengirim data soal..." });
            for (const [index, chunk] of soalChunks.entries()) {
                try {
                    const response = await fetch(`${process.env.REACT_APP_BASE_URL}/admin/sycron/sycronsoal`, {
                        method: "POST",
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': "Bearer " + localStorage.getItem("token")
                        },
                        body: JSON.stringify({ data: chunk }),
                    });

                    if (!response.ok) throw new Error(`Gagal kirim soal batch ke-${index + 1}`);
                    batchSoalSuccess++;

                    Swal.update({
                        html: `Soal batch ke-${index + 1} dikirim. <br>${batchSoalSuccess}/${soalChunks.length} sukses.`,
                    });
                } catch (err) {
                    console.error(`Soal batch ke-${index + 1} gagal:`, err);
                    Swal.update({
                        html: `Soal batch ke-${index + 1} gagal. <br>${batchSoalSuccess}/${soalChunks.length} sukses.`,
                    });
                }

                await new Promise((res) => setTimeout(res, 1000));
            }
            getDataRefrensi(); // Ambil data referensi awal



            // Inisialisasi ulang DataTables setelah data diperbarui
            if (dataPeserta?.jadwal?.length > 0) {
                if ($.fn.dataTable.isDataTable('.table')) {
                    $('.table').DataTable().destroy(); // Hancurkan DataTable yang lama
                }

                $('.table').DataTable({
                    "dom": "<'row'<'col-6 col-sm-6 col-md-9'f><'col-6 col-sm-6 col-md-2 'B><'col-sm-6 col-md-1 float-right'l>><'row'<'col-sm-12'tr>><'row'<'col-sm-12 col-md-10'p><'col-sm-12 col-md-2'i>>",
                    "language": {
                        "search": "",
                        "lengthMenu": "_MENU_"
                    },
                });
            }
            Swal.fire({
                icon: "success",
                title: "Sinkronisasi Selesai!",
                html: `
                    Jawaban sukses: ${batchJawabanSuccess}/${jawabanChunks.length} <br>
                    Soal sukses: ${batchSoalSuccess}/${soalChunks.length}
                `,
            });
            getDataRefrensi(); // Ambil data referensi awal



            // Inisialisasi ulang DataTables setelah data diperbarui
            if (dataPeserta?.jadwal?.length > 0) {
                if ($.fn.dataTable.isDataTable('.table')) {
                    $('.table').DataTable().destroy(); // Hancurkan DataTable yang lama
                }

                $('.table').DataTable({
                    "dom": "<'row'<'col-6 col-sm-6 col-md-9'f><'col-6 col-sm-6 col-md-2 'B><'col-sm-6 col-md-1 float-right'l>><'row'<'col-sm-12'tr>><'row'<'col-sm-12 col-md-10'p><'col-sm-12 col-md-2'i>>",
                    "language": {
                        "search": "",
                        "lengthMenu": "_MENU_"
                    },
                });
            }
        } catch (error) {
            console.error("Gagal sinkronisasi:", error);
            Swal.fire({
                icon: "error",
                title: "Gagal!",
                text: "Terjadi kesalahan saat sinkronisasi data.",
            });
        }
    };


    return (
        <>
            <Helmet>
                <title>Hasil Ujian {dataUjian.nama_mapel || "-"}</title>
            </Helmet>
            <div>
                <div className="pc-container">
                    <div className="pc-content">
                        <div className="row">
                            <div className="col-xl-12 col-md-12">
                                <div className="card">
                                    <div className="card-header">
                                        <h5>Ujian</h5>
                                    </div>
                                    <div className="card-body">
                                        <div className="row g-4">
                                            <div className="col-md-4">
                                                <h7>Pendidik</h7>
                                                <hr />
                                                <h7>{dataUjian.nama_guru}</h7>
                                            </div>
                                            <div className="col-md-4">
                                                <h7>Kelas</h7>
                                                <hr />
                                                <h7>{dataUjian.nama_rombel}</h7>
                                            </div>
                                            <div className="col-md-4">
                                                <h7>Pelajaran</h7>
                                                <hr />
                                                <h7>{dataUjian.nama_mapel}</h7>
                                            </div>
                                            <div className="col-md-4">
                                                <h7>Jumlah Soal</h7>
                                                <hr />
                                                <h7>{jmls}</h7>
                                            </div>
                                            <div className="col-md-4">
                                                <h7>Total Poin</h7>
                                                <hr />
                                                <h7>{totalskor}</h7>
                                            </div>

                                            <div className="col-md-4">
                                                <h7>Jumlah Peserta</h7>
                                                <hr />
                                                <h7>{dataPeserta ? dataPeserta.length : "Loading..."} </h7>
                                            </div>
                                        </div>
                                        <hr />
                                        {dataPeserta.length === 0 ? "Jawaban Peserta dan soal belum ada silahkan tarik data hasil ujian dan soal jika ujian telah dilakukan" : ""}
                                        <hr />
                                        <button className='btn btn-success' onClick={tarikhasilujian}><i className='ti ti-cloud-download'></i> Tarik hasil Ujian</button>
                                        <a href={`/pendidik/viewevaluasi?id_ujian=${dataUjian.id_ujian}`} className="btn btn-primary d-inline-flex"><i className='ti ti-file-invoice'></i> Daftar Soal</a>
                                        <button
                                            className='btn btn-secondary'
                                            onClick={exportToExcel}
                                            disabled={dataPeserta.length === 0}
                                        >
                                            <i className='ti ti-arrow-bar-to-down'></i> Download Hasil Excel
                                        </button>                                        {/* <a  href='#baru' className="btn btn-primary d-inline-flex"><i className='ti ti-arrows-join'></i> Sycron Hasil</a> */}


                                    </div>
                                </div>
                            </div>

                            <div className="col-xl-12 col-md-12">
                                <div className="card">

                                    <div className="card-body">
                                        <div className='row mb-3 align-items-center'>
                                            <div className="col"><small className="text-muted">Refrensi</small><h3>Hasil Tes</h3></div>

                                            <div className='col-auto'>
                                                {/* <button data-bs-toggle="modal" data-bs-target="#ujianModal"  type="button" className="btn btn-primary d-inline-flex"><i className="ti ti-plus me-1"></i>Download Hasil</button> */}
                                            </div>
                                        </div>
                                        <hr />
                                        {/* Tabel kelas */}
                                        <table className="table table-hover datatable-table">
                                            <thead>
                                                <tr>
                                                    <th width="50">#</th>
                                                    <th scope="col">Peserta</th>
                                                    <th width="50">Durasi</th>
                                                    <th width="50">Skor (/100)</th>
                                                    <th width="50"><center>Jawaban Benar (/100)</center></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {dataPeserta?.map((item, index) => {
                                                    let totalBenar = 0; // Menyimpan jumlah jawaban benar
                                                    let skor = 0;
                                                    let poinlalu = 0;
                                                    return (
                                                        <tr key={index}>
                                                            <td scope="row">{index + 1}</td>
                                                            <td><b>{item.nama_peserta}</b></td>
                                                            <td><b>{item.durasi || "-"}</b></td>
                                                            <td>
                                                                <b>
                                                                    {item.jawaban && Array.isArray(JSON.parse(item.jawaban)) ? (
                                                                        JSON.parse(item.jawaban).map((jawabanItem) => {
                                                                            const soalCocok = dataSoal.find((s) => s.id_soal === jawabanItem.idsoal);

                                                                            if (soalCocok) {


                                                                                const jawabanSoal = JSON.parse(soalCocok.jawaban || "[]");
                                                                                const jawabanBenarArr = jawabanSoal
                                                                                    .filter((s) => s.kunci === 1)
                                                                                    .map((s) => s.id_jwb.toString());

                                                                                const jawabanUserArr = Array.isArray(jawabanItem.jawaban)
                                                                                    ? jawabanItem.jawaban.map((s) => s.id_jwb.toString())
                                                                                    : [jawabanItem.jawaban.id_jwb];

                                                                                const isJawabanBenar =
                                                                                    jawabanUserArr.length === jawabanBenarArr.length &&
                                                                                    jawabanUserArr.every((jawaban) => jawabanBenarArr.includes(jawaban));


                                                                                if (isJawabanBenar) {
                                                                                    totalBenar += 1;
                                                                                    poinlalu = soalCocok.poin || 1;
                                                                                    skor += parseFloat(soalCocok.poin) || poinlalu; // Jika poin tidak ada, gunakan 0 agar tidak error
                                                                                    // console.log(item.nama_peserta + "-" + skor)
                                                                                }
                                                                            }

                                                                        })
                                                                    ) : (
                                                                        "Tidak ada jawaban"
                                                                    )} {skor} ({Math.floor((skor / totalskor) * 100)})


                                                                </b>
                                                            </td>
                                                            <td><b>{totalBenar} ({Math.floor((totalBenar / jmls) * 100)})</b></td>
                                                            <td></td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default HasilUjian;
